var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEmail01 = function SvgIconEmail01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 50,
    x2: 100,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.21,14.84H8.79C3.95,14.84,0,18.78,0,23.63v52.73c0,4.86,3.96,8.79,8.79,8.79h82.42c4.84,0,8.79-3.94,8.79-8.79V23.63c0-4.85-3.95-8.79-8.79-8.79ZM89.86,20.7c-2.84,2.85-36.22,36.34-37.59,37.71-1.15,1.15-3.39,1.15-4.54,0L10.14,20.7h79.72ZM5.86,75.29V24.71l25.21,25.29-25.21,25.29ZM10.14,79.3l25.07-25.15,8.38,8.4c3.43,3.44,9.41,3.44,12.84,0l8.38-8.4,25.07,25.15H10.14ZM94.14,75.29l-25.21-25.29,25.21-25.29v50.58Z"
  })));
};
export default SvgIconEmail01;